const FAIL_CREATE_WORKER = 'FAIL_CREATE_WORKER';
export default {
    FAIL_CREATE_WORKER,
};
